import { render, staticRenderFns } from "./ActionsCardComponent.vue?vue&type=template&id=1f8c6266"
import script from "./ActionsCardComponent.vue?vue&type=script&lang=js"
export * from "./ActionsCardComponent.vue?vue&type=script&lang=js"
import style0 from "./ActionsCardComponent.vue?vue&type=style&index=0&id=1f8c6266&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports